import React, { ReactElement, useState } from "react";
import {
    DocumentTableEntry,
    DocumentsTableProps
} from "../../types/DocumentsTableProps";
import {
    DataTable,
    DataTableSelectionSingleChangeEvent
} from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

export const DocumentsTable = (props: DocumentsTableProps): ReactElement => {
    const { t } = useTranslation("common");
    const [selectedDocuments, setSelectedDocuments] = useState<
        DocumentTableEntry[]
    >([]);
    const getLocaleValue = (key: string) => {
        return t(`inspectionReport.documents.${key}`);
    };

    const downloadColumnTemplate = (rowData: DocumentTableEntry) => {
        return (
            <Button
                onClick={() => props.downloadDocument(rowData)}
                type="button"
                icon="pi pi-download"
                className="p-button-secondary p-button-text p-button-sm"
            />
        );
    };

    return (
        <div className="p-datatable-wrapper">
            <DataTable
                value={props.documents}
                onSelectionChange={(
                    e: DataTableSelectionSingleChangeEvent<any>
                ) => setSelectedDocuments(e.value as DocumentTableEntry[])}
                tableClassName="p-datatable-wrapper mb-3"
                selection={selectedDocuments}
                dataKey="elementName"
                selectionAriaLabel="name"
            >
                <Column
                    selectionMode="multiple"
                    headerStyle={{ width: "3em" }}
                />
                <Column
                    field="elementName"
                    header={
                        props.columnHeader ?? getLocaleValue("documentName")
                    }
                />
                <Column
                    headerStyle={{ width: "4rem", textAlign: "center" }}
                    className="justify-content-center table-actions"
                    headerClassName="justify-content-center table-acitons"
                    body={downloadColumnTemplate}
                />
            </DataTable>
            <Button
                onClick={() =>
                    props.downloadSelectedDocuments(selectedDocuments)
                }
                disabled={props.jobInProgress}
                type="button"
                label={getLocaleValue("downloadSelected")}
                icon="pi pi-download"
                className="p-button-secondary p-button-sm"
            />
        </div>
    );
};
